import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';

/**
    props: switchToTable (function), organizationalUnitProperty (Object)
*/

export default class PropertyDetails extends React.Component {
    render() {
        const { organizationalUnitProperty } = this.props;
        let propertyPlaceName = organizationalUnitProperty.property.address.street + ', ' + organizationalUnitProperty.property.address.place.name;
        propertyPlaceName += organizationalUnitProperty.property.address.place.municipality ? ', ' + organizationalUnitProperty.property.address.place.municipality.name : '';
        propertyPlaceName += organizationalUnitProperty.property.address.place.canton ? ', ' + organizationalUnitProperty.property.address.place.canton.name : '';
        propertyPlaceName += organizationalUnitProperty.property.address.place.entity ? ', ' + organizationalUnitProperty.property.address.place.entity.name : '';
        propertyPlaceName += organizationalUnitProperty.property.address.place.country ? ', ' + organizationalUnitProperty.property.address.place.country.name : '';


        return (
            <div>
                <Header as="h1">Nepokretna imovina</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            O nepokretnoj imovini
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={this.props.switchToTable} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Organizaciona jedinica</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.organizationalUnit.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Naziv imovine</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.property ? organizationalUnitProperty.property.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Adresa</b></Table.Cell>
                                    <Table.Cell textAlign="center">{propertyPlaceName}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Korisna površina</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.usefulSurface}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Površina za učenje</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.teachingArea}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Pristup invalidima</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.disabledAccess ? organizationalUnitProperty.disabledAccess.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Tip prava</b></Table.Cell>
                                    <Table.Cell textAlign="center">{organizationalUnitProperty.rightType ? organizationalUnitProperty.rightType.name : null}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyDetails.js